import { Link, useLoaderData } from 'react-router';

import { Badge, Card, Icon, KpiCard, Progress } from '@ds/core';
import { Alert } from '@ds/feedback';
import { PageHeader } from '@/comuns/PageHeader';
import { dados } from '@/data/porta';
import type { CargaDoOnboarding, OnboardingDaClinica } from '@/data/tipos';
import { SITUACAO_DA_CLINICA, quandoRelativo } from './Visao';

export async function carregarOnboarding(): Promise<CargaDoOnboarding> {
    return dados().onboarding();
}

function Etapas({ clinica }: { clinica: OnboardingDaClinica }) {
    return (
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {clinica.etapas.map((e) => (
                <span
                    key={e.id}
                    title={e.descricao}
                    style={{
                        display: 'inline-flex', alignItems: 'center', gap: 6,
                        padding: '4px 9px', borderRadius: 'var(--radius-sm)',
                        border: '1px solid var(--border)',
                        background: e.concluida ? 'var(--success-50, var(--surface-secondary))' : 'var(--surface)',
                        color: e.concluida ? 'var(--text-primary)' : 'var(--text-tertiary)',
                        fontSize: 12.5,
                    }}
                >
                    <Icon name={e.concluida ? 'circle-check' : 'circle-dashed'} size={13} />
                    {e.rotulo}
                </span>
            ))}
        </div>
    );
}

export function Onboarding() {
    const carga = useLoaderData() as CargaDoOnboarding;

    return (
        <div className="vec-screen" style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            <PageHeader
                title="Onboarding"
                description="Onde cada clínica está na implantação — e o que falta para ela começar a usar."
            />

            <div className="vec-stagger" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(170px,1fr))', gap: 12 }}>
                {carga.indicadores.map((i) => (
                    <KpiCard key={i.id} label={i.rotulo} value={i.valor} hint={i.apoio} deltaTone={i.tendencia} icon={<Icon name={i.icone} size={16} />} />
                ))}
            </div>

            {/* O que faz esta lista valer é ela se desmarcar sozinha. */}
            <Alert tone="info" dismissible={false} title="O checklist não é marcado à mão">
                Cada etapa é uma pergunta que o banco responde agora — tem jornada? tem alguém com login? já
                atendeu? Nada aqui é uma caixinha que alguém marca: se a clínica apagar a jornada, a etapa
                desmarca sozinha.
            </Alert>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                {carga.clinicas.map((c) => (
                    <Card key={c.clinicaId} padding={16}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                                <Link to={`/admin/clinicas/${c.clinicaId}`} style={{ fontSize: 14, fontWeight: 600, color: 'var(--text-primary)', textDecoration: 'none' }}>
                                    {c.clinica}
                                </Link>
                                <Badge tone={SITUACAO_DA_CLINICA[c.situacao].tom} dot>{SITUACAO_DA_CLINICA[c.situacao].rotulo}</Badge>
                                <span style={{ fontSize: 12.5, color: 'var(--text-tertiary)' }}>
                                    cliente {quandoRelativo(c.criadoEm)}
                                </span>
                                <span style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 10, minWidth: 'min(200px, 100%)' }}>
                                    <Progress
                                        value={Math.round((c.concluidas / c.total) * 100)}
                                        tone={c.concluidas === c.total ? 'success' : c.concluidas === 0 ? 'warning' : 'brand'}
                                        style={{ flex: 1 }}
                                    />
                                    <span style={{ fontSize: 12.5, fontVariantNumeric: 'tabular-nums', color: 'var(--text-secondary)' }}>
                                        {c.concluidas}/{c.total}
                                    </span>
                                </span>
                            </div>

                            <Etapas clinica={c} />
                        </div>
                    </Card>
                ))}
            </div>
        </div>
    );
}
